<app-page-header
        [title]="'Application Settings'"
        [subtitle]="'Manage application settings for SampleStudio'"
></app-page-header>

<div class="flex-col gap-10 mb-6">

    <!-- Email Settings -->
    <div>
        <div class="mb-2">
            <h2 class="text-2xl text-gray-800 dark:text-gray-100 font-semibold">Email Settings</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400">Define where emails should be sent (separate multiple
                emails with a comma)</p>
        </div>
        <div class="border border-gray-300 dark:border-gray-700 p-4 mb-5 rounded-sm">
            <div class="flex flex-col gap-3">
                <!-- Email for R&D -->
                <p-ifta-label>
                    <p-iconfield>
                        <p-inputicon class="pi pi-envelope"></p-inputicon>
                        <textarea pTextarea
                                  style="min-width: 350px"
                                  rows="2"
                                  id="email-r-and-d"
                                  [(ngModel)]="settings.emailRandD"
                                  autocomplete="off"
                        ></textarea>
                    </p-iconfield>
                    <label for="email-r-and-d">Emails for R&D</label>
                </p-ifta-label>

                <!-- Email for Sample Producer -->
                <p-ifta-label>
                    <p-iconfield>
                        <p-inputicon class="pi pi-envelope"></p-inputicon>
                        <textarea pTextarea
                                  style="min-width: 350px"
                                  rows="2"
                                  id="email-sample-producer"
                                  [(ngModel)]="settings.emailSampleProducer"
                                  autocomplete="off"
                        ></textarea>
                    </p-iconfield>
                    <label for="email-sample-producer">Emails for Sample Producer</label>
                </p-ifta-label>

                <!-- Email for Sample Process Owner -->
                <p-ifta-label>
                    <p-iconfield>
                        <p-inputicon class="pi pi-envelope"></p-inputicon>
                        <textarea pTextarea
                                  style="min-width: 350px"
                                  rows="2"
                                  id="email-sample-process-owner"
                                  [(ngModel)]="settings.emailSampleProcessOwner"
                                  autocomplete="off"
                        ></textarea>
                    </p-iconfield>
                    <label for="email-sample-process-owner">Emails for Sample Process Owner</label>
                </p-ifta-label>

                <!-- Email for Sample Maintainer -->
                <p-ifta-label>
                    <p-iconfield>
                        <p-inputicon class="pi pi-envelope"></p-inputicon>
                        <textarea pTextarea
                                  style="min-width: 350px"
                                  rows="2"
                                  id="email-sample-maintainer"
                                  [(ngModel)]="settings.emailSampleMaintainer"
                                  autocomplete="off"
                        ></textarea>
                    </p-iconfield>
                    <label for="email-sample-maintainer">Emails for Sample Maintainer</label>
                </p-ifta-label>

                <!-- Email for DEP -->
                <p-ifta-label>
                    <p-iconfield>
                        <p-inputicon class="pi pi-envelope"></p-inputicon>
                        <textarea pTextarea
                                  style="min-width: 350px"
                                  rows="2"
                                  id="email-dep"
                                  [(ngModel)]="settings.emailDEP"
                                  autocomplete="off"
                        ></textarea>
                    </p-iconfield>
                    <label for="email-dep">Emails for DEP</label>
                </p-ifta-label>
            </div>
        </div>
    </div>

</div>

<!-- Save Button -->
<div class="flex justify-end mt-4">
    <p-button (click)="saveSettings()" [loading]="loading" icon="pi pi-save" isAdmin label="Save"
              severity="primary"></p-button>
</div>
